import { useState } from "react";
import { Table } from "react-bootstrap";
// import "../../css/NextContentModule.scss";
import backArrowico from "../../images/backArrowico.svg";

const NextModulePreview = (props) => {
  const { previewData, nextPreviewModalHideHandler } = props;

  return (
    <div>
      <div className="next-module-preview">
        <div className="next-preview-first">
          <div className="d-flex align-items-baseline next-module-arrow">
            <img
              src={backArrowico}
              alt=""
              onClick={() => nextPreviewModalHideHandler()}
            />
            <h2 className="next-module-preview-title">Module Preview</h2>
          </div>
          <div className="d-flex justify-content-between next-preview-brand">
            <div className="d-flex justify-content-between">
              <div className="brand-header">
                <h6>Brand</h6>
                <p>{previewData?.brand}</p>
              </div>
              <div className="brand-header">
                <h6>{previewData?.moduleCode}</h6>
                <p>{previewData?.name}</p>
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="brand-header">
                <h6>Campaign</h6>
                <p>{previewData?.campaign}</p>
              </div>
              <div className="brand-header">
                <h6>MLR Status</h6>
                <p>-</p>
              </div>
            </div>
          </div>
        </div>
        <hr className="next-module-horizontal-line" />
        <div className="next-preview-second">
          <h2 className="next-module-preview-specific-information">
            Module-specific information
          </h2>
          <Table className="module-specific-information" bordered size="sm">
            <tbody>
              <tr className="module-specific-cell module-specific-header">
                <td>Module-information</td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td>Name</td>
                <td>{previewData?.name}</td>
              </tr>
              <tr className="module-specific-cell">
                <td>ID</td>
                <td>{previewData?.moduleCode}</td>
              </tr>
              <tr className="module-specific-cell">
                <td>Page number in Master Asset</td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td>Core claim category</td>
                <td>
                  {previewData?.length > 0 ? previewData.coreCategories[0] : ""}
                </td>
              </tr>
              <tr className="module-specific-cell">
                <td>Core claim</td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td>Veeva link to Core Claim/ Core Claim Document</td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td>Audience</td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td>Dosage</td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td>Recommendation on module usage</td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <Table
            className="module-specific-information next-module-business-rules"
            bordered
            size="sm"
          >
            <tbody>
              <tr className="module-specific-cell module-specific-header">
                <td>Business Rules</td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td style={{ fontWeight: "100" }}>
                  <ul>
                    <li>Must Exist With</li>
                  </ul>
                </td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td style={{ fontWeight: "100" }}>
                  <ul>
                    <li>Cannot Exist With</li>
                  </ul>
                </td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td style={{ fontWeight: "100" }}>
                  <ul>
                    <li>Precedes</li>
                  </ul>
                </td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td style={{ fontWeight: "100" }}>
                  <ul>
                    <li>Succeeds</li>
                  </ul>
                </td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td>Other business rules</td>
                <td></td>
              </tr>
              <tr className="module-specific-cell">
                <td>Related modules</td>
                <td></td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default NextModulePreview;
